<template>
  <div v-if="!profileRequesting" style="height: 100vh" class="d-flex flex-column">
    <div style="background-color: #000000" class="container flex-grow-1 pb-5">
      <div class="head mb-5">
        <div class="justify-content-center row">
          <div class="col-lg-7 p-0">
            <ProgressHeader :currentStep="1" />
          </div>
        </div>
      </div>
      <div class="justify-content-center row">
        <div class="col-lg-7">
          <h4>填寫會員資料</h4>
          <h6 style="color: #ff0000">必填欄位*</h6>
          <div class="row my-4">
            <div class="col">
              <h6>姓<span class="required">*</span></h6>
              <b-form-input
                id="lastName"
                type="text"
                v-model="$v.lastName.$model"
                :state="validateState('lastName')"
              />
              <b-form-invalid-feedback id="lastName">必填</b-form-invalid-feedback>
            </div>
            <div class="col">
              <h6>名<span class="required">*</span></h6>
              <b-form-input
                id="firstName"
                type="text"
                v-model="$v.firstName.$model"
                :state="validateState('firstName')"
              />
              <b-form-invalid-feedback id="firstName">必填</b-form-invalid-feedback>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col">
              <h6>手機號碼</h6>
              <div class="row align-items-center">
                <div class="col">
                  <b-form-input v-model="profile.mobile" type="number" disabled />
                  <b-badge class="verify_badge">已驗證</b-badge>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col">
              <h6>身分證字號<span class="required">*</span></h6>
              <b-form-input
                id="nationalId"
                type="text"
                v-model="$v.nationalId.$model"
                :state="validateState('nationalId')"
              />
              <b-form-invalid-feedback id="nationalId">必填</b-form-invalid-feedback>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col">
              <h6>生日<span class="required">*</span></h6>
              <div class="row">
                <div class="col-6 pr-0">
                  <b-input-group>
                    <b-form-select
                      v-model="birthyearType"
                      :options="birthyearTypeOptions"
                    ></b-form-select>
                    <b-form-select
                      v-show="birthyearType === 'bc'"
                      v-model="$v.birthyear.$model"
                      :options="birthyearBCOption"
                    ></b-form-select>
                    <b-form-select
                      v-show="birthyearType === 'roc'"
                      v-model="$v.birthyear.$model"
                      :options="birthyearROCOption"
                    ></b-form-select>
                    <!-- <b-form-input
                      placeholder="年"
                      v-model="$v.birthyear.$model"
                      :state="validateState('birthyear')"
                    ></b-form-input> -->
                  </b-input-group>
                </div>
                <div class="col-6">
                  <b-input-group>
                    <b-form-select
                      v-model="$v.birthmonth.$model"
                      :options="birthMonthOption"
                    ></b-form-select>
                    <!-- <b-form-input
                      placeholder="月"
                      v-model="$v.birthmonth.$model"
                      :state="validateState('birthmonth')"
                    ></b-form-input> -->
                    <b-form-select
                      v-model="$v.birthdate.$model"
                      :options="birthDateOption"
                    ></b-form-select>
                    <!-- <b-form-input
                      placeholder="DD"
                      v-model="$v.birthdate.$model"
                      :state="validateState('birthdate')"
                    ></b-form-input> -->
                  </b-input-group>
                </div>
                <b-form-invalid-feedback id="birthday">必填</b-form-invalid-feedback>
              </div>
            </div>
          </div>
          <!-- <div class="row mb-4">
            <div class="col">
              <h6>車牌</h6>
              <b-form-input id="plateNumber" type="text" v-model="$v.plateNumber.$model" />
              <b-form-invalid-feedback id="plateNumber">必填</b-form-invalid-feedback>
            </div>
          </div> -->
          <div class="row mb-4">
            <div class="col">
              <h6>Email<span class="required">*</span></h6>
              <b-form-input
                id="email"
                type="email"
                v-model="$v.email.$model"
                :state="validateState('email')"
              />
              <b-form-invalid-feedback id="email">必填</b-form-invalid-feedback>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col">
              <h6>通訊地址<span class="required">*</span></h6>
              <div class="row mb-3">
                <div class="col-6 pr-1">
                  <b-form-select
                    :options="city_options"
                    v-model="$v.city.$model"
                    :state="validateState('city')"
                    @change="onCityChange"
                  />
                </div>
                <div class="col-6 pl-1">
                  <div class="row align-items-center">
                    <div class="col">
                      <b-form-select
                        v-model="$v.area.$model"
                        :state="validateState('area')"
                        :options="area_options"
                        @change="onAreaChange"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <b-form-input
                    id="step1_address"
                    v-model="$v.address.$model"
                    :state="validateState('address')"
                    type="text"
                    placeholder="輸入段/路/街/巷/號"
                  />
                  <b-form-invalid-feedback id="step1_address">必填</b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col">
              <label>
                <input type="checkbox" v-model="agreeTerm" /> 我同意PAMO<a
                  href="https://www.pamolaw.com/terms/"
                  >服務使用條款</a
                >
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex fixed-bottom">
      <!-- <div class="flex-fill" @click="logout">
        <Button name="登出" />
      </div> -->
      <div :class="{ disabled: !agreeTerm }" class="flex-fill" @click="onSubmit">
        <Button name="下一步" class="highlight" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, between, numeric } from 'vuelidate/lib/validators';
import { auth, plan, record } from '@/mixins';
import Button from '@/elements/Button.vue';
import ProgressHeader from '@/components/ProgressHeader.vue';
import { persistRefFromURL } from '@/utils/refTracker';

export default {
  mixins: [auth, plan, validationMixin, record],
  name: 'UpdateUser',
  validations: {
    firstName: { required },
    lastName: { required },
    birthyear: {
      required,
      numeric,
      between: between(0, 2000),
    },
    birthmonth: {
      required,
      numeric,
      between: between(0, 11),
    },
    birthdate: {
      required,
      numeric,
      between: between(0, 31),
    },
    birthday: { required },
    nationalId: { required },
    plateNumber: {},
    email: { required },
    address: { required },
    area: { required },
    city: { required },
  },
  computed: {
    ...mapState({
      profileRequesting: (state) => state.auth.profileRequesting,
      profile: (state) => state.auth.profile,
      partnerAuthData: (state) => state.auth.partnerAuthData,
      city_options: (state) => state.records.city,
      area_options: (state) => state.records.area,
      requestingCreateRecord: (state) => state.records.requestingCreateRecord,
      birthyearBCOption() {
        const currentYear = new Date().getFullYear();
        const startYear = 1930;
        const endYear = currentYear - 14;

        const options = [{ value: null, text: '年', disabled: true }];
        for (let y = endYear; y >= startYear; y -= 1) {
          options.push({ value: y.toString(), text: y.toString() });
        }
        return options;
      },
      birthyearROCOption() {
        const currentYear = new Date().getFullYear();
        const startYear = 25;
        const endROC = currentYear - 1911 - 14;

        const options = [{ value: null, text: '年', disabled: true }];
        for (let y = endROC; y >= startYear; y -= 1) {
          options.push({ value: y.toString(), text: y.toString() });
        }
        return options;
      },
    }),
  },
  components: {
    Button,
    ProgressHeader,
  },
  data() {
    return {
      step: 0,
      firstName: '',
      lastName: '',
      email: '',
      city: '1',
      area: '1',
      address: '',
      birthyearTypeOptions: [
        { value: 'roc', text: '民國' },
        { value: 'bc', text: '西元' },
      ],
      birthMonthOption: [
        { value: null, text: '月', disabled: true },
        { value: '0', text: '1' },
        { value: '1', text: '2' },
        { value: '2', text: '3' },
        { value: '3', text: '4' },
        { value: '4', text: '5' },
        { value: '5', text: '6' },
        { value: '6', text: '7' },
        { value: '7', text: '8' },
        { value: '8', text: '9' },
        { value: '9', text: '10' },
        { value: '10', text: '11' },
        { value: '11', text: '12' },
      ],
      birthDateOption: [
        { value: null, text: '日', disabled: true },
        { value: '1', text: '1' },
        { value: '2', text: '2' },
        { value: '3', text: '3' },
        { value: '4', text: '4' },
        { value: '5', text: '5' },
        { value: '6', text: '6' },
        { value: '7', text: '7' },
        { value: '8', text: '8' },
        { value: '9', text: '9' },
        { value: '10', text: '10' },
        { value: '11', text: '11' },
        { value: '12', text: '12' },
        { value: '13', text: '13' },
        { value: '14', text: '14' },
        { value: '15', text: '15' },
        { value: '16', text: '16' },
        { value: '17', text: '17' },
        { value: '18', text: '18' },
        { value: '19', text: '19' },
        { value: '20', text: '20' },
        { value: '21', text: '21' },
        { value: '22', text: '22' },
        { value: '23', text: '23' },
        { value: '24', text: '24' },
        { value: '25', text: '25' },
        { value: '26', text: '26' },
        { value: '27', text: '27' },
        { value: '28', text: '28' },
        { value: '29', text: '29' },
        { value: '30', text: '30' },
        { value: '31', text: '31' },
      ],
      birthyearType: 'roc',
      birthyear: null,
      birthmonth: null,
      birthdate: null,
      birthday: null,
      nationalId: '',
      blockedNationalIds: [
        'G121971770', // 260831申請無使用退費
        'N122904821', // 許富捷，260810申請無使用退費
        'F126659858', // 曾昰銘，續約後通報爭議款項
        'L222805672', // 王邑庭，申請無使用退費
        'F131538697', // 華定橙，申請退費
        'A180001217', // 呂盛萌，260430申請無使用退費
        'M122066003', // 廖本立，260520申請無使用退費
        'F226717606', // 李沁惟，申請無使用退費
        'R123959216', // 胡瀚陽，申請無使用退費
        'H123435670', // 陳昌謚，申請退費
        'Q200161880', // 龔芳玉，續約後提報爭議款項申請退費
        'J123158320', // 林欣皞，20260907申請無使用退費
        'E125005926', // 林智濤，20260908申請無使用退費
        'A131386170', // 鄭羽農，不續約
        'F226006475', // 戴怡亭，無使用退費
        'D222884104', // 杜珆萱，無使用退費
      ],
      agreeTerm: false,
      plateNumber: '',
      end: {
        link: '/',
        action: '下一步',
      },
      refSource: 'unknown',
    };
  },
  mounted() {
    this.fetchCityAndArea();
    if (this.$route.query.auth) {
      this.partnerAuth({
        authToken: this.$route.query.auth,
      });
    }
    this.refSource = persistRefFromURL();
    if (window.gtag) {
      window.gtag('event', 'signup_landing', {
        event_category: 'conversion',
        event_label: this.refSource,
      });
    }

    if (this.$route.query.auth) {
      this.partnerAuth({
        authToken: this.$route.query.auth,
      });
    }
  },
  watch: {
    partnerAuthData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const { firstName, lastName, nationalId, birth, plateNumber, email } =
            this.partnerAuthData.userData;
          this.firstName = firstName;
          this.lastName = lastName;
          this.nationalId = nationalId;
          this.birthday = birth;
          this.plateNumber = plateNumber;
          this.email = email;
        }
      },
    },
    birthyearType: 'convertBirthday',
    birthyear: 'convertBirthday',
    birthmonth: 'convertBirthday',
    birthdate: 'convertBirthday',
  },
  methods: {
    convertBirthday() {
      if (this.birthyearType === 'roc') {
        this.birthday = new Date(this.birthyear, this.birthmonth, this.birthdate);
        const y = new Date(this.birthday).getFullYear();
        const m = new Date(this.birthday).getMonth();
        const d = new Date(this.birthday).getDate();
        this.birthday = new Date(y + 11, m, d);
      } else {
        this.birthday = new Date(this.birthyear, this.birthmonth, this.birthdate);
        const m = new Date(this.birthday).getMonth();
        const d = new Date(this.birthday).getDate();
        this.birthday = new Date(this.birthyear, m, d);
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    logout() {
      this.requestLogout();
    },
    onCityChange(val) {
      this.fetchAreaByCity({
        cityId: val,
        onSuccess: (res) => {
          this.area = res.data[0].id;
        },
      });
    },
    onSubmit() {
      if (this.blockedNationalIds.includes(this.nationalId.trim().toUpperCase())) {
        alert('您的帳號受到限制，請與PAMO聯絡');
        return;
      }

      this.$v.$touch();
      if (this.$v.$anyError) {
        console.log('ss', this.$v.$anyError);
        return;
      }

      const { firstName, lastName, email, birthday, nationalId, plateNumber, address, city, area } =
        this;

      this.updateUser({
        id: this.profile.id,
        firstName,
        lastName,
        email,
        birthday,
        nationalId,
        plateNumber,
        address,
        zipCode: this.area_options.find((v) => v.value === area).zipCode,
        area: this.area_options.find((v) => v.value === area).text,
        city: this.city_options.find((v) => v.value === city).text,
        onSuccess: () => {
          this.refSource = persistRefFromURL(); // 確保來源在最新狀態

          if (window.gtag) {
            window.gtag('event', 'signup_completed', {
              event_category: 'conversion',
              event_label: this.refSource,
            });
          }

          const refQuery = { ref: this.refSource || sessionStorage.getItem('refSource') };

          if (
            this.partnerAuthData &&
            this.partnerAuthData.userData.licenseKey &&
            (this.profile.licenses || []).length === 0
          ) {
            this.addPlan({
              licenseKey: this.partnerAuthData.userData.licenseKey,
              onSuccess: () => {
                this.$router.replace({ path: '/payment/order', query: refQuery });
              },
              onFailed: () => {
                alert('綁定序號時發生錯誤，請聯繫客服。');
              },
            });
          } else {
            this.$router.replace({ path: '/payment/order', query: refQuery });
          }
        },
        onFailed: (err) => {
          switch (err.response.data.apiErrorCode) {
            case 'ACCOUNT_ALREADY_BOUND':
              alert('此帳號已完成註冊步驟，如有疑問，請聯繫客服。');
              break;
            case 'DUPLICATED_NATIONAL_ID':
              alert('此身分證字號已被其他帳號使用。');
              break;
            case 'DUPLICATED_EMAIL':
              alert('此E-mail位置已被其他帳號使用。');
              break;
            default:
              alert('發生錯誤，請再試一次');
              break;
          }
        },
      });
    },
  },
};
</script>
<style>
.required {
  color: #ff0000;
  font-size: 20px;
}

.disabled {
  pointer-events: none;
}

.disabled > div {
  background-color: #463c2f !important;
}

.verify_badge {
  position: absolute;
  top: 10px;
  right: 25px;
}
</style>
